module.exports = __webpack_public_path__ + "static/media/mypharmacy-logo.5a968906.svg";